import { send } from '../../../../../../../src/network/network';

export interface NeveredIngredientOnProduct {
  id: number;
  name: string;
}

export interface NeveredIngredientProduct {
  id: number;
  nevered_ingredients: NeveredIngredientOnProduct[];
}

/**
 * The body key is `results`. BE-8605's ticket example says `products`.
 */
export interface NeveredIngredientProductsResponse {
  results: NeveredIngredientProduct[];
}

export const getApiV3CustomerNeveredIngredientProductsPath = () =>
  '/api/v3/customers/self/nevered_ingredients/products/';

/** Products that contain one of the customer's nevered ingredients. */
export async function getApiV3CustomerNeveredIngredientProducts() {
  return await send<NeveredIngredientProductsResponse>({
    path: getApiV3CustomerNeveredIngredientProductsPath(),
    method: 'GET',
  });
}
